import { DesktopShellInterface } from './Interface';
import type { DesktopShellProps } from './types';

/** Thin container — desktop shell state lives in App for now. */
export default function DesktopShellContainer(props: DesktopShellProps) {
  return <DesktopShellInterface {...props} />;
}
